import React from "react";
import "./VerticalBar.scss"; // SCSS file for styling

interface TimelineItem {
  title: string;
  description: string;
}

interface VerticalBarProps {
  items: TimelineItem[];
  dotSize?: number;
  outlineSize?: number;
  lineHeight?: number;
  color?: string;
  spacing?: number;
}

const VerticalBar: React.FC<VerticalBarProps> = ({
  items,
  dotSize = 12,
  outlineSize = 24,
  lineHeight = 50,
  color = "var(--primary-green)", // Use CSS variable for color
  spacing = 10,
}) => {
  return (
    <div className="verticalTimeline">
      {items.map((item, index) => (
        <div key={index} className="timelineItem">
          <div className="timelineIcon">
            <div
              className="outerCircle"
              style={{
                width: outlineSize,
                height: outlineSize,
                borderColor: color,
              }}
            >
              <div
                className="innerDot"
                style={{
                  width: dotSize,
                  height: dotSize,
                  backgroundColor: color,
                }}
              ></div>
            </div>
            {index < items.length - 1 && (
              <div
                className="line"
                style={{
                  height: lineHeight,
                  backgroundColor: color,
                  marginTop: spacing,
                  marginBottom: spacing,
                }}
              ></div>
            )}
          </div>
          <div className="timelineContent">
            <h4>{item.title}</h4>
            <p>{item.description}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default VerticalBar;
